export default __webpack_public_path__ + "static/media/eye.c5224f21.png";